<template>
  <aside class="marketplace-sidebar">
    <div class="filter-section">
      <label class="filter-title">{{$t('price_range')}}</label>
      <div class="flex-row-div">
        <div class="price-range-row">
          <input type="number" v-model="localFilters.minPrice" placeholder="₺0" class="price-input" />
          <span class="price-separator">-</span>
          <input type="number" v-model="localFilters.maxPrice" placeholder="₺10000" class="price-input" />
        </div>
        <button class="apply-btn" @click="emitFilters">{{$t('apply')}}</button>
      </div>
    </div>

    <div class="filter-section">
      <label class="filter-title">{{ $t('categories') }}</label>
      <div class="checkbox-list">
        <div v-for="(cat, i) in visibleCategories" :key="cat.uuid" class="checkbox-row">
          <input type="checkbox"
                 :id="'cat-' + cat.uuid"
                 v-model="localFilters.selectedCategories"
                 :value="cat.uuid"
                 @change="emitFilters" />
          <label :for="'cat-' + cat.uuid">{{ cat.title }}</label>
        </div>
      </div>
      <button v-if="categories.length > maxCategoryCount" class="show-more" @click="showAllCategories = !showAllCategories">
        {{ showAllCategories ? this.$t('show_less') : this.$t('show_more') }}
      </button>
    </div>

    <div class="filter-section">
      <label class="filter-title">{{ $t('points') }}</label>
      <div class="checkbox-list">
        <div v-for="rating in ratings" :key="rating.value" class="checkbox-row">
          <input type="checkbox"
                 :id="'rating-' + rating.value"
                 v-model="localFilters.ratings"
                 :value="rating.value"
                 @change="emitFilters" />
          <label :for="'rating-' + rating.value">
            {{ rating.label }}
            <span class="stars">{{ rating.stars }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="filter-section">
      <label class="filter-title">{{ $t('currency') }}</label>
      <div class="checkbox-list">
        <div v-for="(cur, i) in visibleCurrencies" :key="cur.code" class="checkbox-row">
          <input type="checkbox"
                 :id="'cur-' + cur.code"
                 v-model="localFilters.selectedCurrencies"
                 :value="cur.code"
                 @change="emitFilters" />
          <label :for="'cur-' + cur.code">{{ cur.label }}</label>
        </div>
      </div>
      <button v-if="currencies.length > maxCurrencyCount" class="show-more" @click="showAllCurrencies = !showAllCurrencies">
        {{ showAllCurrencies ? this.$t('show_less') : this.$t('show_more')  }}
      </button>
    </div>
  </aside>
</template>

<script>
import marketplaceCategoriesService from '@/service/marketplaceCategoriesService';

export default {
  name: 'MarketplaceSidebarFilters',

  props: {
    currentTab: {
      type: String,
      default: 'publicProducts'
    }
  },

  data() {
    return {
      localFilters: {
        minPrice: '',
        maxPrice: '',
        selectedCategories: [],
        ratings: [],
        languages: [],
        selectedCurrencies: []
      },


      tabFilters: {
        publicProducts: {
          minPrice: '', maxPrice: '', selectedCategories: [],
          ratings: [], languages: [], selectedCurrencies: []
        },
        myProducts: {
          minPrice: '', maxPrice: '', selectedCategories: [],
          ratings: [], languages: [], selectedCurrencies: []
        },
        comments: {
          minPrice: '', maxPrice: '', selectedCategories: [],
          ratings: [], languages: [], selectedCurrencies: []
        },
        purchased: {
          minPrice: '', maxPrice: '', selectedCategories: [],
          ratings: [], languages: [], selectedCurrencies: []
        }
      },

      categories: [],
      maxCategoryCount: 5,
      showAllCategories: false,
      ratings: [
        { value: 4, label: '4 '+this.$t('and_above'), stars: '★★★★★' },
        { value: 3, label: '3 '+this.$t('and_above'), stars: '★★★★' },
        { value: 2, label: '2 '+this.$t('and_above'), stars: '★★' }
      ],
      languages: [
        { code: 'all', label: this.$t('all') },
        { code: 'tr', label: 'Türkçe' },
        { code: 'en', label: 'English' },
        { code: 'es', label: 'Spanish' },
        { code: 'it', label: 'Italian' },
        { code: 'ru', label: 'Russian' },
        { code: 'ar', label: 'Arabic' }
      ],
      maxLanguageCount: 5,
      showAllLanguages: false,
      currencies: [
        { code: 'TRY', label: 'TRY' },
        { code: 'USD', label: 'USD' },
        { code: 'EUR', label: 'EUR' }
      ],
      maxCurrencyCount: 3,
      showAllCurrencies: false
    }
  },

  watch: {
    currentTab: {
      handler(newTab, oldTab) {
        if (oldTab && oldTab !== newTab) {
          this.tabFilters[oldTab] = { ...this.localFilters };
          this.localFilters = { ...this.tabFilters[newTab] };
        }
      },
      immediate: false
    }
  },

  computed: {
    visibleCategories() {
      return this.showAllCategories ? this.categories : this.categories.slice(0, this.maxCategoryCount);
    },
    visibleLanguages() {
      return this.showAllLanguages ? this.languages : this.languages.slice(0, this.maxLanguageCount);
    },
    visibleCurrencies() {
      return this.showAllCurrencies ? this.currencies : this.currencies.slice(0, this.maxCurrencyCount);
    }
  },
  created() {
    this.loadCategories();
  },
  methods: {
    async loadCategories() {
      try {
        const response = await marketplaceCategoriesService.getCategories({ page: 1, limit: 100 });
        this.categories = response.data.data?.data || [];
      } catch (e) {
        this.categories = [];
      }
    },

    testFilters() {
    },

    emitFilters() {
      const filters = {};

      if (this.localFilters.minPrice !== '' && Number(this.localFilters.minPrice) > 0) {
        filters.minPrice = this.localFilters.minPrice;
      }

      if (this.localFilters.maxPrice !== '' && Number(this.localFilters.maxPrice) > 0) {
        filters.maxPrice = this.localFilters.maxPrice;
      }

      if (this.localFilters.selectedCategories && this.localFilters.selectedCategories.length > 0) {
        filters.marketplaceCategoryIds = this.localFilters.selectedCategories;
      }

      if (this.localFilters.ratings && this.localFilters.ratings.length > 0) {
        filters.ratings = this.localFilters.ratings;
      }

      if (this.localFilters.selectedCurrencies && this.localFilters.selectedCurrencies.length > 0) {
        filters.currencies = this.localFilters.selectedCurrencies;
      }

      if (this.localFilters.languages && this.localFilters.languages.length > 0) {
        filters.languages = this.localFilters.languages;
      }

      this.testFilters();
      this.$emit('filters-changed', filters);
    },

    clearFilters() {
      this.localFilters = {
        minPrice: '',
        maxPrice: '',
        selectedCategories: [],
        ratings: [],
        languages: [],
        selectedCurrencies: []
      };
      this.emitFilters();
    }

  }
}
</script>

<style scoped>
.marketplace-sidebar {
  width: 280px;
  background: transparent;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: 'euclid_medium', sans-serif;
}
.filter-section {
  margin-bottom: 10px;
}
.filter-title {
  font-size: 14px;
  color: #1c1d1f;
  margin-bottom: 12px;
  display: block;
  padding-bottom: 5px;
  border-bottom: 1px solid #D0D5DD;
  font-family: 'euclid_medium', 'sans-serif';
}
.price-range-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.flex-row-div{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.price-input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #d1d7dc;
  border-radius: 8px;
  font-size: 14px;
}
.price-separator {
  color: #6c757d;
  font-size: 16px;
}
.apply-btn {
  background: #040C2D;
  color: #fff;
  border: none;
  border-radius: 12px ;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.apply-btn:hover {
  background: #0036CC;
}
.checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.checkbox-list label{
  font-size: 14px;
  font-family: "euclid-regular", sans-serif;
  color: #040c2d;
}
.checkbox-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.stars {
  color: #FFB400;
  margin-left: 4px;
  font-size: 13px;
}
.show-more {
  background: none;
  color: #0044FF;
  border: none;
  font-size: 13px;
  cursor: pointer;
  margin-top: 4px;
  text-decoration: underline;
}
.show-more:hover {
  color: #0036CC;
}
</style>
